import { app } from '../../../../app';
import { Controller } from './shared-folders.controller';

app.component('companySharingCenterSharedFolders', {
    bindings: {
        sharedFolders: '<',
    },
    controller: Controller,
    templateUrl: require('./shared-folders.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/sharing-center/shared-folders/shared-folders.component.js